import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PopupAHSF from "../../Components/PopupAHSF";
import TableAHSF from "../../Components/TableAHSF";
import { encryptToken } from "../../Services/Account/EncryptionToken";
import Swal from "sweetalert2";
import { initializeApiClient } from "../../Services/apiService";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import AddEditeTransferInformation from "./AddEditeTransferInformation";
import {
  DeletePR_TransferItemInformation,
  GetOnePR_TransferItemInformationByID,
} from "../../Redux/Reducers/ReportStage/TransferItemInformation";
import ButtonAHSF from "../../Components/ButtonAHSF";
import { ChangeRportStatusByAppGUID } from "../../Redux/Reducers/ReportStage/Report";

const TransferItemInformationSubmitter = (props) => {
  const dispatch = useDispatch();
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const [pR_TransferItemInformationGuid, setpR_TransferItemInformationGuid] =
    useState();
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "stageFromTransferName",
      ShowStatus: true,
      NmaeColumn: " المرحلة التي تمت المناقلة منها ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemTypeFromName",
      ShowStatus: true,
      NmaeColumn: "نوع البند الذي تمت المناقلة منه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemFromTransferName",
      ShowStatus: true,
      NmaeColumn: "اسم البند الذي تمت المناقلة منه ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "stageToTransferName",
      ShowStatus: true,
      NmaeColumn: " المرحلة التي تمت المناقلة اليها",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemTypeToName",
      ShowStatus: true,
      NmaeColumn: "نوع البند الذي تمت المناقلة اليه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "itemToTransferName",
      ShowStatus: true,
      NmaeColumn: "اسم البند الذي تمت المناقلة اليه",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "transferValue",
      ShowStatus: true,
      NmaeColumn: "قيمة المناقلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusName",
      ShowStatus: true,
      NmaeColumn: "حالة طلب المناقلة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        setpR_TransferItemInformationGuid(e.target.value);
        const one = await dispatch(
          GetOnePR_TransferItemInformationByID(e.target.value)
        );
        setPopUpBodyStatus(true);
      },
      content: "",
      className: !props.shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },

    {
      Click: async (e) => {
        Swal.fire({
          title: "تأكيد عملية الحذف",
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          // Callback triggered after user interacts with the popup.
          if (res.isConfirmed == true) {
            // If the user confirms the action:
            const deleted = await dispatch(
              DeletePR_TransferItemInformation(e.target.value)
            );
            if (deleted.payload == " Success ") {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: !props.shouldDisableFields,
    },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <AddEditeTransferInformation />
      </div>
    ),

    title: "المناقلات",
    maxWidth: "31%",
    maxHeight: "40%",
    idssss: "",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: (
      <div>
        <AddEditeTransferInformation
          pR_TransferItemInformationGuid={pR_TransferItemInformationGuid}
        />
      </div>
    ),

    title: "المناقلات",
    maxWidth: "31%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };
  const ApplayTransfer = async () => {
    const applay = await dispatch(
      ChangeRportStatusByAppGUID({
        PR_ReportStatusGuid: "984469c1-753a-4f9e-8ba9-39ef70f15542",
        AP_ApplicationInformationGUID: localStorage.getItem(
          "aI_ApplicationInformationId"
        ),
      })
    );
    if(applay.payload){
        Swal.fire({
            position: "center",
            icon: "success",
            title: "تم تقديم المناقلات بنجاح",
            showConfirmButton: false,
            timer: 1500,
            // width: "500px",
          });
          //to refresh table
          
    }
  };
  const shouldDisableFields = "";

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_TransferItemInformationGuid"}
        valueButtonAction={"pR_TransferItemInformationGuid"}
        URL={`api/TransferItemInformation/GetPR_TransferItemInformationListByApplicationGuid`}
        UrlBody={{
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={true}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
      <div className="containersButton">
        <div>
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              ApplayTransfer();
            }}
            disabled={false}
            title={"تقديم المناقلات"}
            text={"تقديم المناقلات"}
            show={true}
          />
        </div>
      </div>
    </>
  );
};
export default TransferItemInformationSubmitter;
